import { FiasDivision, FiasSchema } from '../types';
export var defaultDivision = FiasDivision.Administrative;
export var defaultSchema = FiasSchema.Fias;
export var RUSSIA = {
    shortName: 'Россия',
    fullName: 'Российская Федерация',
    code: '643',
};
